<template>
<div style="height: 100%; display: flex; flex-direction: column;">
    <input class="form-control" type="search" ref="SearchField" v-on:keydown.enter="onSearch">
    <div style="flex: 1; overflow:auto;">
        <preloader v-if="loading"></preloader>
        <table class="table table-hover table-sm">
            <thead>
            <tr>
                <th>Citation</th>
                <th>Line No.</th>
                <th>Period</th>
                <th>Provenience</th>
                <th>Match</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "row in rows" :key="row['row_number']"
                v-on:click="$emit('tablet-selected', row['tablet_id']); active_row = row['row_number']"
                v-bind:class="{'table-active': row['row_number'] == active_row}">
                <td>{{ row['citation'] }}</td>
                <td>{{ row['line_no'] }}</td>
                <td>{{ row['period'] }}</td>
                <td>{{ row['provenience'] }}</td>
                <td v-html="row['line']"></td>
            </tr>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
  import Preloader from '@/components/Preloader';
  import axios from 'axios'
  
  export default {

    data () {
      return {
        rows: [],
        active_row: 0,
        loading: false
      }
    },

    components: {
      Preloader
    },

    methods: {
      onSearch: function (event) {
        this.rows = [];
        this.loading = true;
        if (this.$refs.SearchField.value) {
          axios.post("/db/search", {
              searchString: this.$refs.SearchField.value
            })
            .then(response => {
              this.loading = false;
              this.rows = response.data.rows;
            })
            .catch(e => {
              console.log(e);
            })
        }
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Search.vue